module.exports = __webpack_public_path__ + "img/20190614161713670.aca36642.png";